import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Autocomplete,
  Chip,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";

const AddAdminDialog = ({
  open,
  onClose,
  onAddAdmin,
  staffList,
  loading,
  setSelectedStaff,
  selectedStaff,
}) => {
  const handleAddAdmin = () => {
    // Prepare the selected staff data to include employee_id
    const selectedStaffIds = selectedStaff?.map((staff) => ({
      employee_id: staff?.id,
      email: staff?.email,
      name: staff?.name,
    }));

    onAddAdmin(selectedStaffIds);
    onClose();
    setSelectedStaff([]);
  };

  return (
    <Dialog
      open={open}
      onClose={() => {
        onClose();
        setSelectedStaff([]);
      }}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle fontWeight={"bold"}>Add New Admin</DialogTitle>
      <DialogContent dividers sx={{ minHeight: "300px !important" }}>
        <Autocomplete
          multiple
          options={staffList?.filter((staff) => staff?.in_scope !== false) || []}
          getOptionLabel={(option) =>
            option?.name
          }
          value={selectedStaff}
          onChange={(event, newValue) => setSelectedStaff(newValue)}
          isOptionEqualToValue={(option, value) => option?.id === value?.id}
          renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Chip
                key={index}
                label={option?.name}
                {...getTagProps({ index })}
              />
            ))
          }
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder={
                selectedStaff?.length === 0
                  ? "Start Typing to Search for a Person"
                  : ""
              }
              required
              fullWidth
            />
          )}
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            onClose();
            setSelectedStaff([]);
          }}
          variant="outlined"
          color="primary"
        >
          Cancel
        </Button>
        <LoadingButton
          onClick={handleAddAdmin}
          variant="contained"
          color="primary"
          disabled={selectedStaff?.length === 0}
          loading={loading}
        >
          Add Admin
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default AddAdminDialog;
